<template>
	<div>
		<v-tabs
			v-model="tabs"
			background-color="light-primary"
			active-class="mid-primary"
			color="transparent"
		>
			<div v-for="(ele, index) in tabsArray" :key="index">
				<v-tab
					class="white--text"
					:to="{
						name: ele.pageName,
						query: { employeeId: $route.query.employeeId, name: $route.query.name },
					}">
					{{ ele.title }}
				</v-tab>
			</div>
			<v-tab
				class="white--text"
				:to="{
					name: 'interview-ranking',
					query: { employeeId: $route.query.employeeId, name: $route.query.name },
				}">
				{{ $T('tabs.interviewRanking') }}
			</v-tab>
			<v-tab
				class="white--text"
				:to="{
					name: 'employee-performance',
					query: { employeeId: $route.query.employeeId, name: $route.query.name },
				}">
				{{ $T('tabs.employeePerformance') }}
			</v-tab>

			<v-tab
				class="white--text"
				:to="{
					name: 'evaluate-performance-during-the-experiment',
					query: { employeeId: $route.query.employeeId, name: $route.query.name },
				}">
					تقييم أداء موظف فني
			</v-tab>

			<v-tab
				class="white--text"
				:to="{
					name: 'technical-performance',
					query: { employeeId: $route.query.employeeId, name: $route.query.name },
				}">
					تقييم أداء موظف من خلال التجربة
			</v-tab>

			<v-tab
				class="white--text"
				:to="{
					name: 'job-satisfaction-questionnaire',
					query: { employeeId: $route.query.employeeId, name: $route.query.name },
				}">
				استبيان رضا وظيفي
			</v-tab>
		</v-tabs>

		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'AddInterview',

	data() {
		return {
			tabs: null,
			tabsArray: [
				{
					pageName: 'interview-ranking'
				},
				{
					pageName: 'employee-performance'
				},
				{
					pageName: 'evaluate-performance-during-the-experiment'
				},
				{
					pageName: 'technical-performance'
				},
				{
					pageName: 'job-satisfaction-questionnaire'
				}
			],
			loading: false
		};
	},

	created() {
		this.loading = true
		this.$store.dispatch('evaluation/fetchAll').then((data) => {
			data.forEach(element => {
				this.tabsArray.title = element.evaluationName 
			});
		})
	}
};
</script>

<style lang="scss" scoped></style>
